import { ensureString } from 'ensure-string';
import { XMLParser } from 'fast-xml-parser';

import { appendEquipment } from './utils/appendEquipment.js';
import { appendMeasure } from './utils/appendMeasure.js';

export function voidVolumeParserHitec(measure, others = {}) {
  const parser = new XMLParser();
  const parsed = {};

  appendMeasure(parsed, ensureString(measure));

  for (let key in others) {
    let json = parser.parse(ensureString(others[key]));
    switch (key) {
      case 'equipment':
        appendEquipment(parsed, json);
        break;
      default:
        break;
    }
  }

  return parsed;
}
